import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/offer", label: "The Experience", testid: "nav-offer-link" },
  { to: "/membership", label: "Membership", testid: "nav-membership-link" },
  { to: "/hotels", label: "For Hotels", testid: "nav-hotels-link" },
  { to: "/join", label: "For Barbers", testid: "nav-join-link" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-ink/70 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3" onClick={() => setOpen(false)}>
          <img src="/logo-crest.png" alt="LUXGROOM crest" className="h-9 md:h-10 w-auto" />
          <img src="/logo-wordmark.png" alt="LUXGROOM" className="h-4 md:h-5 w-auto" />
        </Link>
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `text-xs uppercase tracking-[0.25em] transition-colors ${
                  isActive ? "text-gold" : "text-white/60 hover:text-[#FDFBF7]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/offer"
            data-testid="nav-book-cta"
            className="text-xs uppercase tracking-[0.2em] bg-gold text-black px-6 py-3 hover:bg-gold-light transition-colors"
          >
            Book your visit
          </Link>
        </nav>
        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white/80 hover:text-gold transition-colors"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <nav data-testid="nav-mobile-menu" className="md:hidden border-t border-white/10 bg-ink/95 backdrop-blur-xl px-6 py-8 flex flex-col gap-6">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`${l.testid}-mobile`}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `text-sm uppercase tracking-[0.25em] ${isActive ? "text-gold" : "text-white/70"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/offer"
            data-testid="nav-book-cta-mobile"
            onClick={() => setOpen(false)}
            className="text-xs uppercase tracking-[0.2em] bg-gold text-black px-6 py-3 text-center hover:bg-gold-light transition-colors"
          >
            Book your visit
          </Link>
        </nav>
      )}
    </header>
  );
};
